<div :class="$style.progressBar">
    <div id="progressContainer" :class="$style.progressBarContainer">
        <div :class="$style.circularProgress">
            <div id="mainContent" :class="$style.valueContainer">
                {{progressPerc}}%
            </div>
        </div>
    </div>
</div>